/**
 * Class strings shared by the career growth surfaces: the "Croissance" tab of the performance
 * profile and the employee portal. Constants rather than utilities in `app.css` so moving a block
 * between sections cannot shift a pixel; colours come from the `growth-*` family declared in
 * `app.css`, never from a hex written here.
 */

/** The translucent fill: a white hairline over a 45% white fill, lightly blurred. */
export const GROWTH_GLASS_FILL = 'border border-white bg-white/45 backdrop-blur-[2px]';

/** The translucent card of a section; the career objective card alone draws a wider radius. */
export const GROWTH_GLASS_SURFACE = `rounded-2xl ${GROWTH_GLASS_FILL}`;

/**
 * The side padding every glass surface shares: the design's 16px on phones and 22px from `md`.
 * Sixteen is the `px-4` step; twenty-two falls between two steps, which is why it stays written
 * out. Declared on its own because a surface may set its own vertical rhythm while staying in the
 * same column.
 */
export const GROWTH_SECTION_PADDING_X = 'px-4 md:px-[22px]';

/** The padding of a glass section: the shared sides, and the same rhythm above and below. */
export const GROWTH_SECTION_PADDING = `${GROWTH_SECTION_PADDING_X} py-4 md:py-[22px]`;

/**
 * The near-opaque fill of a panel a glass section nests (the skills grid, a note, an aspiration
 * question). Declared on its own because a nested panel may set its own radius while staying the
 * same white.
 */
export const GROWTH_PANEL_FILL = 'bg-white/90';

/** The near-opaque panel a glass section nests (the skills grid, a note). */
export const GROWTH_PANEL_SURFACE = `rounded-xl ${GROWTH_PANEL_FILL}`;

/**
 * The block title of every section: the design's 20px over a flat 25px line box, which is why the
 * line height is written out rather than left to `leading-tight`.
 */
export const GROWTH_SECTION_TITLE = 'text-navy text-[20px] leading-[25px] font-medium';
